import React from 'react';
import { Navigate } from 'react-router-dom';
import ForcePasswordResetDialog from './ForcePasswordResetDialog';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      <ForcePasswordResetDialog />
      {children}
    </>
  );
}

export default ProtectedRoute;
